import { render, staticRenderFns } from "./AttachmentRequiredClone.vue?vue&type=template&id=2e7a7464&scoped=true"
import script from "./AttachmentRequiredClone.vue?vue&type=script&lang=js"
export * from "./AttachmentRequiredClone.vue?vue&type=script&lang=js"
import style0 from "./AttachmentRequiredClone.vue?vue&type=style&index=0&id=2e7a7464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a7464",
  null
  
)

export default component.exports